import { generateNamesObject } from '@orbis-systems/orbis-react-toolkit';

import { Box, Divider, Typography, alpha, styled } from '@mui/material';

export const userProfileInfoClasses = generateNamesObject(
	['value', 'settingsPanel', 'logout', 'version'],
	'UserProfileInfoClasses',
);

export const StyledDivider = styled(Divider)(({ theme }) => ({
	borderWidth: 1,
	borderColor: theme.palette.divider,
}));

export const VerificationStatusBadge = styled(Typography, {
	shouldForwardProp: prop => prop !== 'verified',
})<{ verified?: boolean }>(({ theme, verified }) => ({
	display: 'inline-block',
	fontSize: 11,
	fontWeight: 600,
	lineHeight: 1.5,
	letterSpacing: '0.04em',
	padding: theme.spacing(0.25, 1),
	borderRadius: 4,
	marginTop: theme.spacing(0.5),
	color: verified ? theme.palette.success.main : theme.palette.error.main,
	backgroundColor: alpha(verified ? theme.palette.success.main : theme.palette.error.main, 0.12),
}));

export const UserProfileInfoContainer = styled(Box)(({ theme }) => ({
	[`& .${userProfileInfoClasses.value}`]: {
		wordBreak: 'break-all',
	},
	[`& .${userProfileInfoClasses.version}`]: {
		fontSize: '10px',
		lineHeight: 1.66,
		marginTop: theme.spacing(0.5),
	},
	[`& .${userProfileInfoClasses.logout}`]: {
		'&:hover': {
			color: theme.palette.primary.main,
			'svg path': {
				fill: theme.palette.primary.main,
			},
		},
		'& svg path': {
			fill: theme.darkMode ? theme.palette.common.white : theme.palette.common.black,
		},
	},
	[`& .${userProfileInfoClasses.settingsPanel}`]: {
		backgroundColor: alpha(theme.palette.primary.main, theme.darkMode ? 0.2 : 0.1),
		padding: theme.spacing(2),
		margin: '16px -20px -20px',
		width: 'calc(100% + 40px)',
		cursor: 'pointer',
	},
}));
